module.exports = __webpack_public_path__ + "static/img/CF.77e460f0.svg";